import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getAnalytics, isSupported } from 'firebase/analytics'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
  // TODO: Replace with your Firebase config
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: "https://aiscoringapp-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Realtime Database (for existing functionality)
export const database = getDatabase(app)

// Initialize Firestore (for admin, membership, and pricing)
export const firestore = getFirestore(app)

// Initialize Authentication
export const auth = getAuth(app)

// Initialize Analytics (only if supported)
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null)

// Initialize Functions
export const functions = getFunctions(app)

// Initialize Storage
export const storage = getStorage(app)

export { app } 